export const clientListFilterEmptyValue = -1;

export type ClientListFilter = {
  searchText: string;
  circleId: string | typeof clientListFilterEmptyValue;
};
